import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from '@chakra-ui/react';

import { InactiveUserResult } from 'data/user/schemas';
import { Button } from 'common/materials';

type Props = {
    title?: string;
    isOpen: boolean;
    result?: InactiveUserResult;
    onClose: () => void;
    hideEmptyPositionMessage?: boolean;
};

function SectionHeader({ label, success }: { label: string; success?: boolean }) {
    return (
        <div className="flex items-center gap-2">
            <span className="font-semibold text-sm">{label}</span>
            {success !== undefined && (
                <span className={`text-xs font-medium ${success ? 'text-green-600' : 'text-red-600'}`}>
                    {success ? '✓ สำเร็จ' : '✗ ไม่สำเร็จ'}
                </span>
            )}
        </div>
    );
}

function InactiveResultModal({ title = 'ผลลัพธ์การ Inactive ผู้ใช้งาน', isOpen, result, onClose, hideEmptyPositionMessage = false }: Props) {
    return (
        <Modal size="xl" isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody className="flex flex-col gap-4">

                    {/* F1 Section */}
                    {result?.f1_result && (
                        <div className="rounded border p-3 space-y-1">
                            <SectionHeader label="focusOne" success={result.f1_result.success} />
                            {!result.f1_result.success && result.f1_result.error && (
                                <p className="text-sm text-red-600">{result.f1_result.error}</p>
                            )}
                        </div>
                    )}

                    {/* Workflow Section */}
                    {result?.workflow_result && (
                        <div className="rounded border p-3 space-y-2">
                            <SectionHeader label="Workflow" success={result.workflow_result.success} />
                            {!result.workflow_result.success && result.workflow_result.error && (
                                <p className="text-sm text-red-600">{result.workflow_result.error}</p>
                            )}
                            {result.workflow_result.success && result.workflow_result.result_list && result.workflow_result.result_list.length > 0 && (
                                <table className="w-full text-xs border-collapse">
                                    <thead>
                                        <tr className="bg-gray-100">
                                            <th className="border px-2 py-1 text-left">Position Code</th>
                                            <th className="border px-2 py-1 text-left">จาก</th>
                                            <th className="border px-2 py-1 text-left">เป็น</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {result.workflow_result.result_list.map((item, idx) => (
                                            <tr key={idx}>
                                                <td className="border px-2 py-1">{item.positioncode}</td>
                                                <td className="border px-2 py-1">{item.from_value}</td>
                                                <td className="border px-2 py-1">{item.to_value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                            {result.workflow_result.success && result.workflow_result.total_count === 0 && !hideEmptyPositionMessage && (
                                <p className="text-sm text-gray-500">ไม่มี position ที่เปลี่ยนแปลง</p>
                            )}
                        </div>
                    )}

                    {/* DMS Section */}
                    {result?.dms_result && (
                        <div className="rounded border p-3 space-y-1">
                            <SectionHeader label="DMS" success={result.dms_result.success} />
                            {!result.dms_result.success && result.dms_result.error && (
                                <p className="text-sm text-red-600">{result.dms_result.error}</p>
                            )}
                        </div>
                    )}

                    {!result?.f1_result && !result?.workflow_result && !result?.dms_result && (
                        <p className="text-sm text-gray-500">ไม่มีผลลัพธ์จากระบบภายนอก</p>
                    )}

                </ModalBody>
                <ModalFooter>
                    <Button size="sm" onClick={onClose} className="bg-primary-900 text-white">
                        ปิด
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default InactiveResultModal;
